import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Override16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_403)'>
      <path
        d='M6.46973 4.0303L9.68939 7.24997L1 7.24997L1 8.74997L9.6894 8.74997L6.46973 11.9696L7.53039 13.0303L12.5607 7.99997L7.53039 2.96964L6.46973 4.0303Z'
        fill='currentColor'
      />
      <path
        d='M13.75 2.49997L13.75 13.5H15.25L15.25 2.49997L13.75 2.49997Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_403'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='translate(0 16) rotate(-90)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Override16.displayName = 'Override16';
export default Override16;
